<div class="query-builder-container">
  <mat-accordion style="position: sticky; top: 0;">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <b>
          {{ 'TRANS__ADVANCED_SEARCH__FILTER_SECTION_HEADING' | translate }}
        </b>

        <span>:</span>

        @if (deletedStateValue === 'NOT_DELETED') {
          <span>
            {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__NOT_DELETED' | translate }}
          </span>
        }
        @else if (deletedStateValue === 'DELETED') {
          <span>
            {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__DELETED_ONLY' | translate }}
          </span>
        }
        @else if (deletedStateValue === 'ALL') {
          <span>
            {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__ALL' | translate }}
          </span>
        }

        @if (selectedArtifactIdsControl.value) {
          <span>:</span>
        }

        <span>
          {{ selectedArtifactNames$ | async }}
        </span>
      </mat-expansion-panel-header>

      <mat-divider></mat-divider>

      <div class="filter-label">
        {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE_LABEL' | translate }}
      </div>

      <mat-button-toggle-group
        [(value)]="deletedStateValue"
        (valueChange)="handleDeletedStateChanged()"
      >
        <mat-button-toggle value="NOT_DELETED">
          {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__NOT_DELETED' | translate }}
        </mat-button-toggle>

        <mat-button-toggle value="DELETED">
          {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__DELETED_ONLY' | translate }}
        </mat-button-toggle>

        <mat-button-toggle value="ALL">
          {{ 'TRANS__ADVANCED_SEARCH__FILTER__DELETED_STATE__ALL' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <div class="filter-label">
        {{ 'TRANS__ADVANCED_SEARCH__FILTER__SELECT_OBJECT_TYPE_HINT' | translate }}
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>
          {{ 'TRANS__ADVANCED_SEARCH__FILTER__SELECT_OBJECT_TYPE_LABEL' | translate }}
        </mat-label>

        <mat-select
          [formControl]="selectedArtifactIdsControl"
          multiple
        >
          @for (group of selectableArtifactIds; track $index) {
            <mat-optgroup [label]="group.groupName">
              @for (option of group.options; track $index) {
                <mat-option [value]="option">
                  {{ option.name }}
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
      </mat-form-field>
    </mat-expansion-panel>
  </mat-accordion>

  @for (group of queryService.getCurrentQuery(); track $index) {
    <div
      class="predicate-group-wrapper"
      [cdkDropListData]="group"
      (cdkDropListDropped)="onDrop($event)"
      cdkDropList
    >
      <div class="operand-selector-wrapper">
        @for (p of queryService.getAvailableOperands(); track $index) {
          <button
            class="operand-selector"
            mat-stroked-button
            color="accent"
            [ngClass]="{'active': p.operand === group.operand}"
            (click)="changeOperand(group, p.operand)"
          >
            {{ p.label | translate }}
          </button>
        }
      </div>

      <div
        class="predicate-group predicate-group-color"
        (click)="selectGroup($event, group)"
        (keydown)="null"
      >
        <button
          mat-icon-button
          type="button"
          [disabled]="!enableRemoveGroupButton()"
          class="close-group-button"
          [matTooltip]="'TRANS__ADVANCED_SEARCH__REMOVE_GROUP_TOOLTIP' | translate"
          (click)="removeGroup($event, group)"
        >
          <mat-icon>
            close
          </mat-icon>
        </button>

        @for (field of group.queryFields; track $index) {
          <div
            class="predicate-field-wrapper"
            [cdkDragData]="field"
            [cdkDragDisabled]="deviceType === 'mobile'"
            [cdkDragStartDelay]="deviceType === 'tablet' ? 300 : 0"
            (click)="$event.stopPropagation()"
            (keydown)="null"
            cdkDrag
          >
            <div class="operand-selector-wrapper">
              @for (p of queryService.getAvailableOperands(); track $index) {
                <button
                  mat-button
                  [ngClass]="{'active': p.operand === field.operand}"
                  (click)="changeOperand(field, p.operand)"
                >
                  {{ p.label | translate }}
                </button>
              }
            </div>

            <div class="predicate-field">
              <i class="icon-expand drag-icon"></i>

              <span class="field-title" [matTooltip]="field.label + ' ' + field.secondaryLabel">
                <span>
                  {{field.label}}
                </span>

                @if (field.secondaryLabel) {
                  <span class="alternate-name">
                    ({{ field.secondaryLabel }})
                  </span>
                }
              </span>

              <span class="input-container">
                <app-input
                  [field]="field"
                  [useFreeTextSearch]="queryService.isFreeTextMode(field)"
                  (searchValueChanged)="handleSearchValueChanged(field, $event)"
                ></app-input>
              </span>

              <span class="field-config-container">
                @if (queryService.canUseFreeTextSearch(field)) {
                  @if (queryService.canUseFreeTextSearch(field)) {
                    <mat-slide-toggle
                      [checked]="queryService.isFreeTextMode(field)"
                      (toggleChange)="queryService.toggleFreeTextMode(field)"
                    >
                      {{ 'TRANS__ADVANCED_SEARCH__FREE_TEXT_SEARCH_PLACEHOLDER' | translate }}
                    </mat-slide-toggle>
                  }
                }
              </span>

              <span class="remove-field-button-container">
                <button
                  mat-icon-button
                  type="button"
                  color="warn"
                  [matTooltip]="'TRANS__ADVANCED_SEARCH__REMOVE_FIELD_TOOLTIP' | translate"
                  (click)="removeField($event, group, field)"
                >
                  <mat-icon>
                    delete
                  </mat-icon>
                </button>
              </span>
            </div>


            <div class="advanced-search-drag-preview" *cdkDragPreview>
              <span class="field-title">
                {{ field.label }}
              </span>
            </div>

            <div class="predicate-field-wrapper" *cdkDragPlaceholder>
              <div class="predicate-field">
                <span class="field-title">
                  {{ field.label }}
                </span>
              </div>
            </div>
          </div>
        }

        @if (!group.queryFields.length && deviceType !== 'mobile') {
          <span class="no-content-message">
            {{ 'TRANS__ADVANCED_SEARCH__NO_FIELDS_SELECTED' | translate }}
          </span>
        }

        @if (deviceType === 'mobile') {
          <span class="no-content-message" >
            {{ 'TRANS__ADVANCED_SEARCH__ADD_FIELDS_LABEL' | translate }}
          </span>
        }
      </div>
    </div>
  }
</div>
